module.exports = __webpack_public_path__ + "img/cofinanciamento2.2cf0059f.png";